module.exports = __webpack_public_path__ + "img/imageLib-button.42d8c7b7.png";